import { render, staticRenderFns } from "./Toppings.vue?vue&type=template&id=6a3f205f&scoped=true"
import script from "./toppings.js?vue&type=script&lang=js&external"
export * from "./toppings.js?vue&type=script&lang=js&external"
import style0 from "../admin.scss?vue&type=style&index=0&id=6a3f205f&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a3f205f",
  null
  
)

export default component.exports